import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userLoginMutation } from "../api/Common/Login/login";
import { userOnboardingMutation } from "api/SuperAdmin/UserOnboarding/userOnboarding";
import { userTypeMutation } from "api/SuperAdmin/UserOnboarding/userType";
import { userDataMutation } from "api/SuperAdmin/UserOnboarding/userData";
import { contactUploadListMutation } from "api/Enterprise/ContactList/uploadList";
import { contactGetUploadListMutation } from "api/Enterprise/ContactList/getUploadList";
import { userCheckMutation } from "api/Common/CheckUser/checkUserDetails";
import { userDropDownMutation } from "api/Common/UserDropDown/userDropDown";
import { verifyOtpMutation } from "api/Common/Login/verifyOtp";
import { insertTransactionMutation } from "api/SuperAdmin/Wallet/insertTransaction";
import { transactionalListMutation } from "api/SuperAdmin/Wallet/getTransactionalList";
import { userUpdateFieldMutation } from "api/SuperAdmin/UserOnboarding/userEditField";
import { approveUserMutation } from "api/SuperAdmin/UserOnboarding/approveuser";
import { getUserBalanceMutation } from "api/SuperAdmin/Wallet/getUserBalance";
import { deleteContactListMutation } from "api/Enterprise/ContactList/deleteList";
import { getSMSTemplatesMutation } from "api/Enterprise/Template/getSMSTemp";
import { createSMSTemplateMutation } from "api/Enterprise/Template/createSMSTemp";
import { SMSTestingMutation } from "api/SuperAdmin/ChannelTesting/smsTesting";
import { getCampaignListMutation } from "api/Enterprise/Campaign/getCampaigns";
import { verifyCampaignNameMutation } from "api/Enterprise/Campaign/verifyCampaignName";
import { deleteCampaignListMutation } from "api/Enterprise/Campaign/deleteCampaignList";
import { getWhatsappTemplatesMutation } from "api/Enterprise/Template/WhatsApp/getWhatsappTemp";
import { createWhatsappTempMutation } from "api/Enterprise/Template/WhatsApp/postTemplates";
import { WhatsAppTestingMutation } from "api/SuperAdmin/ChannelTesting/whatsappTesting";
import { uploadMedia } from "api/Common/mediaToUrl/mediaToUrl";
import { createCampaignMutation } from "api/Enterprise/Campaign/createCampaign";
import { blacklistSMSTemplatesMutation } from "api/Enterprise/Template/blacklistTemplate";
import { getRoutesList } from "api/SuperAdmin/routeManage/routesList";
import { getMsgRatesList } from "api/SuperAdmin/MessageRate/getRateList";
import { postRate } from "api/SuperAdmin/MessageRate/postRate";
import { yearlySalesDetails } from "api/Common/Dashboard/yearlySales";
import { yearlySalesDetailsCRM } from "api/Common/Dashboard/yearlySalesCRM";
import { totalContactsOnly } from "api/Common/Dashboard/totalContactsonly";
import { CampaignCountDetails } from "api/Common/Dashboard/campaignCounts";
import { overviewCards } from "api/Common/Dashboard/overviewCards";
import { GetTemplateCount } from "api/Common/Dashboard/getTemplateCount";
import { GetAllUserSA } from "api/Common/Dashboard/getAllUserSA";
import { GetCRMEnterpriseCount } from "api/Common/Dashboard/getCRMEnterpriseCount";
import { CampaignFile } from "api/Enterprise/Campaign/campaignFile";
import { CampaignSummary } from "api/Common/Reports/Campaign";
import { deactivateWhatsTemplates } from "api/Enterprise/Template/WhatsApp/deactivateTemp";
import { ChannelOverview } from "api/Common/Dashboard/channel-piecharts";
import { CDRDetails } from "api/Common/Reports/CDRDetails";
import { ViewBills } from "api/Enterprise/Campaign/viewBills";
import { DownloadCenter } from "api/Common/Reports/DownloadCenter";
import { verifyListNameMutation } from "api/Enterprise/ContactList/verifyListName";
import { uploadMediaGetId } from "api/Enterprise/Template/WhatsApp/mediaID";
import { GetCdrDetailList } from "api/Common/Reports/CDRDetailList";
import { successRate } from "api/Common/Dashboard/successRate";
import { PostFlow } from "api/Enterprise/ChatBotFlow/postFlow";
import { GetFlows } from "api/Enterprise/ChatBotFlow/getFlows";
import { GetFlowNodes } from "api/Enterprise/ChatBotFlow/getFlowNodes";
import { ChangeFlowStatus } from "api/Enterprise/ChatBotFlow/changeStatus";
import { registeredAccountsMutation } from "api/SuperAdmin/UserOnboarding/smsregister";
import { accountRegisterMutation } from "api/SuperAdmin/UserOnboarding/accountRegister";
import { getVendorListMutation } from "api/SuperAdmin/Vendor/vendorList";
import { smscRegistrationMutation } from "api/SuperAdmin/UserOnboarding/smscregister";
import { registeredSMSCMutation } from "api/SuperAdmin/UserOnboarding/smscRegisterList";
import { registeredSMSRateManagement } from "api/SuperAdmin/UserOnboarding/smscRateManagementList";
import { UpdateFlow } from "api/Enterprise/ChatBotFlow/updateFlow";
import { insertVendorTransactionMutation } from "api/SuperAdmin/Wallet/postVendor";
import { getVendorTable } from "api/SuperAdmin/Wallet/getVendorsList";
import { getVendorOptions } from "api/SuperAdmin/Wallet/vendorOptions";
import { listOfRoutes } from "api/SuperAdmin/UserOnboarding/mapping/listOfRoutes";
import { vendorRegistrationMutation } from "api/SuperAdmin/Vendor/vendorRegistration";
import { updateMapping } from "api/SuperAdmin/UserOnboarding/mapping/updateMapping";
import { createRoute } from "api/SuperAdmin/DefaultRouting/createRoute";
import { getRoutingList } from "api/SuperAdmin/DefaultRouting/getRouting";
import { getERUforEA } from "api/Common/UserDropDown/ERUforEA";
import { getEUforEA } from "api/Common/UserDropDown/EUforEA";
import { getRoutesOfEA } from "api/Common/UserDropDown/RoutesOfEA";
import { EnterpriseGroup } from "api/Enterprise/Onboarded/getEtypeUsers";
import { createSMSCRate } from "api/SuperAdmin/UserOnboarding/createRate";
import { updateRoutesMapping } from "api/SuperAdmin/UserOnboarding/mapping/updateRouteMapping";
import { wabaOnboardingMutation } from "api/Enterprise/waba/waba_onboarding";
import { wabaForEu } from "api/Enterprise/waba/getWabaForEU";
import { getShortUrls } from "api/Enterprise/ShortUrl/getShortUrls";
import { routesOfEAForEU } from "api/Enterprise/Routes/getroutesforEU";
import { getEsmeList } from "api/SuperAdmin/Monitoring/esmeList";
import { getSmscList } from "api/SuperAdmin/Monitoring/smscList";
import { getMappedRUEUList } from "api/SuperAdmin/mapped/mappedRuEu";
import { getSmscForVendor } from "api/SuperAdmin/Vendor/getSMSCid";
import { errorCodeSummary } from "api/Common/Reports/errorCodeSummary";
import { CDRforSms } from "api/Common/Reports/smsCDR";
import { userEngagement } from "api/Common/Reports/UserEnagagement";
import { failoverReports } from "api/Common/Reports/failover";
import { scheduledCamp } from "api/Common/Reports/scheduledCamp";
import { CountriesOptions } from "api/Common/Countries/getCountries";
import { CampaignSummaryReports } from "api/Common/Reports/campaignSummary";
import { getVendorBalanceMutation } from "api/SuperAdmin/Wallet/getVendorBalance";
import { costBillingWA } from "api/Common/Reports/costBilling";
import { dnldCamp } from "api/Common/Reports/dnldCamp";
import { dnld_SMS_CDR } from "api/Common/Reports/dnldSMScdr";
import { dnldErrorCodes } from "api/Common/Reports/dnldErrorCode";
import { dnldScheduledCamp } from "api/Common/Reports/dnldScheduledCamp";
import { dnld_WA_CDR } from "api/Common/Reports/dnldWAcdr";
import { dnldWAUserMang } from "api/Common/Reports/dnldUserMang";
import { dnldCostBilling } from "api/Common/Reports/dnldCostBilling";
import { dnldFailoverReport } from "api/Common/Reports/dnldFailoverReport";
import { dnldChannelInsights } from "api/Common/Reports/dnldChannelInsights";
import { dnldUserData } from "api/SuperAdmin/UserOnboarding/dnldUserData";
import { dnldSMSAccountData } from "api/SuperAdmin/UserOnboarding/dnldSmsRegister";
import { dnldSMSCAccountsData } from "api/SuperAdmin/UserOnboarding/dnldSMSCaccounts";
import { dnldSMSCRates } from "api/SuperAdmin/UserOnboarding/dnldSmscRates";
import { dnldWARates } from "api/SuperAdmin/UserOnboarding/dnldWaRates";
import { dnldRouteMapping } from "api/SuperAdmin/UserOnboarding/mapping/dnldRoutes";
import { dnldRuMapping } from "api/SuperAdmin/UserOnboarding/mapping/dnldRUmapping";
import { dnldVendorsList } from "api/SuperAdmin/UserOnboarding/dnldVendorsList";
import { dnldVendorWallet } from "api/SuperAdmin/Wallet/dnldVendorWallet";
import { dnldEntWallet } from "api/SuperAdmin/Wallet/dnldEntWallet";
import { dnldCampaignSummary } from "api/Common/Reports/dnldCampSummary";
import { dnldSMSAccounts } from "api/SuperAdmin/UserOnboarding/dnldSMSaccounts";
import { dnldCampaigns } from "api/Enterprise/Campaign/dnldCampaigns";
import { dnldSMSTemplates } from "api/Enterprise/Template/dnldSmsTemplates";
import { dnldWhatsAppTemplates } from "api/Enterprise/Template/dnldWhatsAppTemplates";
import { senderLists } from "api/SuperAdmin/SenderIDRegistration/getSendersList";
import { createSenderID } from "api/SuperAdmin/SenderIDRegistration/createSenderID";
import { updateSenderID } from "api/SuperAdmin/SenderIDRegistration/approveReject";
import { entByCountry } from "api/SuperAdmin/SenderIDRegistration/entByCountry";
import { categoriesByEnt } from "api/SuperAdmin/SenderIDRegistration/getCategories";
import { dnldSenderLists } from "api/SuperAdmin/SenderIDRegistration/dnldSenderId";
import { deleteSmsAccount } from "api/SuperAdmin/UserOnboarding/deleteSmsAccount";
import { editSmsAccount } from "api/SuperAdmin/UserOnboarding/editSmsAcct";
import { deleteSmscAccount } from "api/SuperAdmin/UserOnboarding/deleteSmscAcct";
import { editSmscAccount } from "api/SuperAdmin/UserOnboarding/editSmscAcct";
import { deleteVendorAccount } from "api/SuperAdmin/Vendor/deleteVendor";
import { editVendorAccount } from "api/SuperAdmin/Vendor/editVendor";
import { RCSCampaignSummary } from "api/Common/Reports/rcsCampaignSum";
import { dnldRCSCampaignSummary } from "api/Common/Reports/dnldRcsCampSum";
import { rcsErrorCodeSummary } from "api/Common/Reports/rcsErrorCodes";
import { dnldRCSErrorCodeSummary } from "api/Common/Reports/dnldRcsErrorCode";
import { deleteAnyUser } from "api/SuperAdmin/UserOnboarding/deleteAnyUser";
import { deleteRoutes } from "api/Enterprise/Routes/deleteRoutes";
import { deleteRouteMapping } from "api/Common/UserDropDown/deleteRouteMapping";
import { editRouteMapping } from "api/SuperAdmin/DefaultRouting/editRouting";
import { deleteRuEuMapping } from "api/SuperAdmin/mapped/deleteRuEuMapping";
import { testAPI } from "api/Enterprise/ChatBotFlow/APIconfig/testAPI";
import { saveAPIs } from "api/Enterprise/ChatBotFlow/APIconfig/saveAPI";
import { GetStoredAPIs } from "api/Enterprise/ChatBotFlow/APIconfig/getStoredApis";
import { dnldSavedApis } from "api/Enterprise/ChatBotFlow/APIconfig/dnldSavedApis";
import { deleteSavedAPIs } from "api/Enterprise/ChatBotFlow/APIconfig/deleteApis";
import { getOtpForReset } from "api/Common/ResetPass/getOtp";
import { resetPass } from "api/Common/ResetPass/resetPassword";
import { RCSCdrReports } from "api/Common/Reports/rcsCdrReports";
import { dnldRCScdrReports } from "api/Common/Reports/dnldRCScdr";

export const postApi = createApi({
  reducerPath: "antiphishingServices",

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_PORT,
  }),

  endpoints: (builder) => ({
    // Dashboard
    ...yearlySalesDetails(builder),
    ...yearlySalesDetailsCRM(builder),
    ...totalContactsOnly(builder),
    ...CampaignCountDetails(builder),
    ...overviewCards(builder),
    ...GetTemplateCount(builder),
    ...GetAllUserSA(builder),
    ...GetCRMEnterpriseCount(builder),
    ...ChannelOverview(builder),
    ...CampaignSummary(builder),
    ...CDRDetails(builder),
    ...DownloadCenter(builder),
    ...successRate(builder),
    ...CDRforSms(builder),
    ...userEngagement(builder),
    ...failoverReports(builder),
    ...scheduledCamp(builder),
    ...CampaignSummaryReports(builder),
    ...costBillingWA(builder),

    // Super-Admin
    ...userLoginMutation(builder),
    ...userOnboardingMutation(builder),
    ...userTypeMutation(builder),
    ...userDataMutation(builder),
    ...userCheckMutation(builder),
    ...userDropDownMutation(builder),
    ...verifyOtpMutation(builder),
    ...insertTransactionMutation(builder),
    ...insertVendorTransactionMutation(builder),
    ...getVendorTable(builder),
    ...getVendorOptions(builder),
    ...transactionalListMutation(builder),
    ...userUpdateFieldMutation(builder),
    ...approveUserMutation(builder),
    ...getUserBalanceMutation(builder),
    ...getVendorBalanceMutation(builder),
    ...SMSTestingMutation(builder),
    ...WhatsAppTestingMutation(builder),
    ...getRoutesList(builder),
    ...getMsgRatesList(builder),
    ...getVendorListMutation(builder),
    ...postRate(builder),
    ...registeredAccountsMutation(builder),
    ...accountRegisterMutation(builder),
    ...smscRegistrationMutation(builder),
    ...registeredSMSCMutation(builder),
    ...registeredSMSRateManagement(builder),
    ...listOfRoutes(builder),
    ...vendorRegistrationMutation(builder),
    ...updateMapping(builder),
    ...createRoute(builder),
    ...getRoutingList(builder),
    ...getERUforEA(builder),
    ...getEUforEA(builder),
    ...getRoutesOfEA(builder),
    ...createSMSCRate(builder),
    ...updateRoutesMapping(builder),
    ...getEsmeList(builder),
    ...getSmscList(builder),
    ...getSmscForVendor(builder),
    ...errorCodeSummary(builder),
    ...CountriesOptions(builder),

    // Enterprise
    ...contactUploadListMutation(builder),
    ...contactGetUploadListMutation(builder),
    ...deleteContactListMutation(builder),
    ...getWhatsappTemplatesMutation(builder),
    ...createWhatsappTempMutation(builder),
    ...deactivateWhatsTemplates(builder),
    ...getSMSTemplatesMutation(builder),
    ...createSMSTemplateMutation(builder),
    ...blacklistSMSTemplatesMutation(builder),
    ...getCampaignListMutation(builder),
    ...verifyCampaignNameMutation(builder),
    ...deleteCampaignListMutation(builder),
    ...uploadMedia(builder),
    ...createCampaignMutation(builder),
    ...CampaignFile(builder),
    ...ViewBills(builder),
    ...verifyListNameMutation(builder),
    ...uploadMediaGetId(builder),
    ...GetCdrDetailList(builder),
    ...EnterpriseGroup(builder),
    ...wabaOnboardingMutation(builder),
    ...wabaForEu(builder),
    ...getShortUrls(builder),
    ...routesOfEAForEU(builder),
    ...getMappedRUEUList(builder),
    ...senderLists(builder),
    ...createSenderID(builder),
    ...updateSenderID(builder),
    ...entByCountry(builder),
    ...categoriesByEnt(builder),


    ...PostFlow(builder),
    ...ChangeFlowStatus(builder),
    ...GetFlows(builder),
    ...GetFlowNodes(builder),
    ...UpdateFlow(builder),

    ...dnldCamp(builder),
    ...dnld_SMS_CDR(builder),
    ...dnldErrorCodes(builder),
    ...dnldScheduledCamp(builder),
    ...dnld_WA_CDR(builder),
    ...dnldWAUserMang(builder),
    ...dnldCostBilling(builder),
    ...dnldFailoverReport(builder),
    ...dnldChannelInsights(builder),
    ...dnldUserData(builder),
    ...dnldSMSAccountData(builder),
    ...dnldSMSCAccountsData(builder),
    ...dnldSMSCRates(builder),
    ...dnldWARates(builder),
    ...dnldRouteMapping(builder),
    ...dnldRuMapping(builder),
    ...dnldVendorsList(builder),
    ...dnldVendorWallet(builder),
    ...dnldEntWallet(builder),
    ...dnldCampaignSummary(builder),
    ...dnldSMSAccounts(builder),
    ...dnldCampaigns(builder),
    ...dnldSMSTemplates(builder),
    ...dnldWhatsAppTemplates(builder),
    ...dnldSenderLists(builder),
    ...deleteSmsAccount(builder),
    ...editSmsAccount(builder),
    ...deleteSmscAccount(builder),
    ...editSmscAccount(builder),
    ...deleteVendorAccount(builder),
    ...editVendorAccount(builder),

    ...RCSCampaignSummary(builder),
    ...dnldRCSCampaignSummary(builder),
    ...rcsErrorCodeSummary(builder),
    ...dnldRCSErrorCodeSummary(builder),
    ...deleteAnyUser(builder),
    ...deleteRoutes(builder),
    ...deleteRouteMapping(builder),
    ...editRouteMapping(builder),
    ...deleteRuEuMapping(builder),

    ...testAPI(builder),
    ...saveAPIs(builder),
    ...GetStoredAPIs(builder),
    ...dnldSavedApis(builder),
    ...deleteSavedAPIs(builder),

    ...getOtpForReset(builder),
    ...resetPass(builder),
    ...RCSCdrReports(builder),
    ...dnldRCScdrReports(builder),
  }),
});

export const {
  useUserLoginMutation,
  useUserOnboardingMutation,
  useUserTypeMutation,
  useUserDataMutation,
  useContactUploadListMutation,
  useContactGetUploadListMutation,
  useDeleteListMutation,
  useCheckUserDetailsMutation,
  useUserDropDownMutation,
  useVerifyOtpMutation,
  useInsertTransactionMutation,
  useInsertVendorTransactionMutation,
  useGetVendorOptionsMutation,
  useGetVendorTableMutation,
  useTransactionalListMutation,
  useGetWhatsappTemplatesMutation,
  useCreateWhatsappTempMutation,
  useUserUpdateFieldMutation,
  useApproveUserMutation,
  useGetUserBalanceMutation,
  useGetSMSTemplatesMutation,
  useCreateSMSTemplateMutation,
  useSmsTestingMutation,
  useGetCampaignListMutation,
  useVerifyCampaignNameMutation,
  useDeleteCampListMutation,
  useWhatsAppTestingMutation,
  useUploadMediaMutation,
  useCreateCampaignMutation,
  useBlacklistSMSTemplatesMutation,
  useGetRoutesListMutation,
  useGetMsgRatesListMutation,
  usePostRateMutation,
  useYearlySalesDetailsMutation,
  useYearlySalesDetailsCRMMutation,
  useTotalContactsOnlyMutation,
  useCampaignCountDetailsMutation,
  useOverviewCardsMutation,
  useGetTemplateCountMutation,
  useGetAllUserSAMutation,
  useGetCRMEnterpriseCountMutation,
  useCampaignFileMutation,
  useDeactivateWhatsTemplatesMutation,
  useCampaignSummaryMutation,
  useChannelOverviewMutation,
  useCDRDetailsMutation,
  useViewBillsMutation,
  useDownloadCenterMutation,
  useVerifyListNameMutation,
  useUploadMediaGetIdMutation,
  useGetCdrDetailListMutation,
  useSuccessRateMutation,
  useGetVendorListMutation,
  useListOfRoutesMutation,
  useVendorRegistrationMutation,
  useUpdateMappingMutation,
  useGetERUforEAMutation,
  useGetEUforEAMutation,
  useGetRoutesOfEAMutation,
  useUpdateRoutesMappingMutation,

  useCreateRouteMutation,
  useGetRoutingListMutation,
  useEnterpriseGroupMutation,

  usePostFlowMutation,
  useChangeFlowStatusMutation,
  useGetFlowsMutation,
  useGetFlowNodesMutation,
  useUpdateFlowMutation,

  useGetRegisteredAccountsMutation,
  useAccountRegisterMutation,
  useSmscRegistrationMutation,
  useGetRegisteredSMSCAccountsMutation,
  useRegisteredSMSRateManagementMutation,
  useCreateSMSCRateMutation,
  useWabaOnboardingMutation,
  useWabaForEuMutation,
  useGetShortUrlsMutation,
  useRoutesOfEAForEUMutation,
  useGetEsmeListMutation,
  useGetSmscListMutation,
  useGetMappedRUEUListMutation,
  useGetSmscForVendorMutation,
  useErrorCodeSummaryMutation,
  useCDRforSmsMutation,
  useUserEngagementMutation,
  useFailoverReportsMutation,
  useScheduledCampMutation,
  useCountriesOptionsMutation,
  useCampaignSummaryReportsMutation,
  useGetVendorBalanceMutation,
  useCostBillingWAMutation,
  useDnldCampMutation,
  useDnld_SMS_CDRMutation,
  useDnldErrorCodesMutation,
  useDnldScheduledCampMutation,
  useDnld_WA_CDRMutation,
  useDnldWAUserMangMutation,
  useDnldCostBillingMutation,
  useDnldFailoverReportMutation,
  useDnldChannelInsightsMutation,
  useDnldUserDataMutation,
  useDnldSMSAccountDataMutation,
  useDnldSMSCAccountsDataMutation,
  useDnldSMSCRatesMutation,
  useDnldWARatesMutation,
  useDnldRouteMappingMutation,
  useDnldRuMappingMutation,
  useDnldVendorsListMutation,
  useDnldVendorWalletMutation,
  useDnldEntWalletMutation,
  useDnldCampaignSummaryMutation,
  useDnldSMSAccountsMutation,
  useDnldCampaignsMutation,
  useDnldSMSTemplatesMutation,
  useDnldWhatsAppTemplatesMutation,
  useSenderListsMutation,
  useCreateSenderIDMutation,
  useUpdateSenderIDMutation,
  useEntByCountryMutation,
  useCategoriesByEntMutation,
  useDnldSenderListsMutation,
  useDeleteSmsAccountMutation,
  useEditSmsAccountMutation,
  useDeleteSmscAccountMutation,
  useEditSmscAccountMutation,
  useDeleteVendorAccountMutation,
  useEditVendorAccountMutation,
  useRCSCampaignSummaryMutation,
  useDnldRCSCampaignSummaryMutation,
  useRcsErrorCodeSummaryMutation,
  useDnldRCSErrorCodeSummaryMutation,
  useDeleteAnyUserMutation,
  useDeleteRoutesMutation,
  useDeleteRouteMappingMutation,
  useEditRouteMappingMutation,
  useDeleteRuEuMappingMutation,
  useTestAPIMutation,
  useSaveAPIsMutation,
  useGetStoredAPIsMutation,
  useDnldSavedApisMutation,
  useDeleteSavedAPIsMutation,
  useGetOtpForResetMutation,
  useResetPassMutation,
  useRCSCdrReportsMutation,
  useDnldRCScdrReportsMutation,
  useCreateTenantMutation,
  useGetTenantQuery,
  useLazyGetTenantQuery,


} = postApi;
